<template>
    <div>
        <div class="mb10">
            <el-page-header @back="toListPage" content="基建数据导出">
                <span slot="title" class="font14px text-bold" v-matomo="{behaviorCategory: '自助工具(基建数据导出)', event: '点击',  name: '返回'}">返回</span>
                <span slot="content" class="font14px text-color-gray">基建数据导出</span>
            </el-page-header>
        </div>
        <div class="form-wrap">
            <el-form :model="formItem" :rules="rules" ref="form" @submit.native.prevent label-position="top" label-width="150px">
                <el-form-item label="媒体：" prop="plat_id">
                    <div slot="label" class="inline-block">
                        <span class="text-bold">媒体：</span>
                    </div>
                    <el-radio-group v-model="formItem.plat_id" @change="changePlat">
                        <el-radio-button v-if="allowedPlatIds.includes('1')" label="1">OPPO</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('3')" label="3">vivo</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('4')" label="4">华为</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('10')" label="10">华为Ads</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('11')" label="11">荣耀</el-radio-button>
                        <el-radio-button v-if="allowedPlatIds.includes('7')" label="7">小米</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="创建日期：" prop="" class="label-required">
                    <div slot="label" class="inline-block">
                        <span class="text-bold">创建日期：</span>
                        <span class="text-normal">（计划/广告组/广告/创意）</span>
                    </div>
                    <el-date-picker
                        v-model="range"
                        type="daterange"
                        :clearable="false"
                        range-separator="至"
                        value-format="yyyy-MM-dd"
                        start-placeholder="开始日期"
                        :picker-options="pickerOptions"
                        @change="changeRangeTime"
                        end-placeholder="结束日期">
                    </el-date-picker>
                    <span class="ml20 text-bold">※ 日期跨度最大366天</span>
                </el-form-item>
                <el-form-item label="">
                    <div class="dialog-footer tac">
                        <el-button type="default" @click="toListPage" class="action-btn mr20" v-matomo="{behaviorCategory: '自助工具(基建数据导出)', event: '点击',  name: '取消'}">取消</el-button>
                        <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '自助工具(基建数据导出)', event: '点击',  name: '导出'}">导出</el-button>
                    </div>
                </el-form-item>
                <div class="mt20">
                    <h3 class="mt10 mb10">数据说明</h3>
                    <div class="pl20 tip-text">
                        <p>媒体包含的数据列：</p>
                        <p class="mb10" v-if="formItem.plat_id=='1'">
                            <span class="text-bold">OPPO：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、投放场景、流量场景、运营人员、计划创建日期、广告组创建日期、广告创建日期、
                            <span class="text-bold">计划创建数、广告组创建数、广告创建数</span>
                        </p>
                        <p class="mb10" v-if="formItem.plat_id=='3'">
                            <span class="text-bold">vivo：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、计划类型、展现形式、运营人员、计划创建日期、广告组创建日期、广告创建日期、创意创建日期、
                            <span class="text-bold">计划创建数、广告组创建数、广告创建数、创意创建数</span>
                        </p>
                        <p class="mb10" v-if="formItem.plat_id=='4'">
                            <span class="text-bold">华为：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、运营人员、任务创建日期、子任务创建日期、
                            <span class="text-bold">任务创建数、子任务创建数</span>
                        </p>
                        <p class="mb10" v-if="formItem.plat_id=='10'">
                            <span class="text-bold">华为Ads：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、投放场景、投放版位、运营人员、计划创建日期、任务创建曰期、创意创建日期、
                            <span class="text-bold">计划创建数、任务创建数、创意创建数</span>
                        </p>
                        <p class="mb10" v-if="formItem.plat_id=='11'">
                            <span class="text-bold">荣耀：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、投放场景、投放位置、运营人员、计划创建日期、分组创建日期、创意创建日期、
                            <span class="text-bold">计划创建数、分组创建数、创意创建数</span>
                        </p>
                        <p class="mb10" v-if="formItem.plat_id=='7'">
                            <span class="text-bold">小米：<br/></span>
                            包体类型、游戏分类、集团名称、产品名称、产品ID、产品包名、账户ID、计划类型、版位类型、运营人员、计划创建日期、广告组创建日期、创意创建日期、
                            <span class="text-bold">计划创建数、广告组创建数、创意创建数</span>
                        </p>
                        <div class="mt20">
                            <p>说明：数据为媒体按创建日期分天，对应维度下各广告层级的创建数量。暂不支持列选择或数据汇总，可导出后按需汇总。</p>
                            <p class="pl60">仅可导出在聚投有数据权限的媒体账户的基建数据。</p>
                            <p class="pl60">各维度同步聚投综合查询分析平台，如有问题参考平台的数据检查或修复流程。</p>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import API from '@/api/efficiencyTool/assisttools.js';
    import dayjs from 'dayjs';

    export default {
        name: "BaseExportPage",
        props:{
            allowedPlatIds:Array,
        },
        data(){
            let _this = this;
            return {
                formItem:{
                    plat_id:'',
                },
                rules:{
                    plat_id:[
                        { required: true, message: '请选择媒体', trigger: 'change' },
                    ],
                    range:[
                        { required: true, type: 'array',message: '请选择创建日期', trigger: 'change' },
                    ],
                },
                submitLoading:false,
                range:[],
                pickerOptions:{
                    firstDayOfWeek:1,
                    disabledDate(time){
                        let pickedDate = _this.pickedDate;
                        if(!pickedDate){
                            // return time.getTime() > Date.now() || time.getTime() < new Date().getTime()-1000*60*60*24*367;
                            return time.getTime() > Date.now();
                        }else{
                            if(time.getTime() > Date.now()) return true;
                            return (time.getTime() > pickedDate.getTime()+1000*60*60*24*366)||(time.getTime() < pickedDate.getTime()-1000*60*60*24*367);
                        }
                    },
                    onPick:({ maxDate, minDate })=>{
                        if(maxDate===null&&!!minDate){
                            _this.pickedDate = minDate
                        }else if(!!maxDate&&!!minDate){
                            // _this.pickedDate = null;
                        }
                    },
                },
                pickedDate:null,
            }
        },
        mounted(){
            console.log('mounted',this.allowedPlatIds);
            this.setDefaultPlat();
            this.setRange();
        },
        methods:{
            setDefaultPlat(){
                let platList = this.allowedPlatIds||[];
                /* 目前仅支持OPPO、vivo渠道 */
                if(platList.includes('1')||platList.includes(1)){
                    this.formItem.plat_id = '1';
                }else if(platList.includes('3')||platList.includes(3)){
                    this.formItem.plat_id = '3';
                }else if(platList.includes('4')||platList.includes(4)){
                    this.formItem.plat_id = '4';
                }else if(platList.includes('7')||platList.includes(7)){
                    this.formItem.plat_id = '7';
                }else if(platList.includes('10')||platList.includes(10)){
                    this.formItem.plat_id = '10';
                }else if(platList.includes('11')||platList.includes(11)){
                    this.formItem.plat_id = '11';
                }
            },
            setRange(){
                let yesDay = new Date(Date.now()-1000*60*60*24);
                let year = yesDay.getFullYear();
                let month = yesDay.getMonth()+1;
                let day = yesDay.getDate();
                month = month<10?'0'+month:month;
                day = day<10?'0'+day:day;
                let yesStr = year+'-'+month+'-'+day;
                this.range = [yesStr,yesStr];
            },
            toListPage(){
                console.log('toListPage');
                this.resetForm();
                this.$emit('back');
            },
            resetForm(){
                console.log('resetForm');
                this.$refs.form.resetFields();
                this.setDefaultPlat();
            },
            changePlat(val){
                console.log('changePlat',val);
            },
            changeRangeTime(val){
                console.log('changeRangeTime',val);
                this.pickedDate = null;
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.infrastructureDataExport({
                            plat_id:this.formItem.plat_id,
                            range_time:this.range.join('/'),
                        }).then(res=>{
                            console.log('infrastructureDataExport',res);

                            this.submitLoading = false;
                            this.$message.success(res.info||'');
                            this.resetForm();

                        },err=>{
                            console.log('infrastructureDataExport err',err);
                            this.submitLoading = false;

                            let errData = err.data||[];
                            if(err.code==0&&errData.length>0){
                                this.$alert(err.info||'请求失败',{
                                    type:'error',
                                    title: err.info||'请求失败',
                                    dangerouslyUseHTMLString: true,
                                    message: "<div class='font12px' style='max-height: 300px;overflow-y: auto;word-break: break-all;'>"+errData.join('、')+"</div>",
                                    duration: 0
                                });
                            }else{
                                if(err.code!=500){
                                    this.$message.error(err.info||'操作失败');
                                }
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form-wrap{
        max-width: 1000px;
        margin: 20px 10px 10px;
    }

    .tip-text{
        color: #333;
    }
</style>
